import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "rounded",
  "use": "rounded-usage",
  "viewBox": "0 0 12 10",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 12 10\" id=\"rounded\"><path fill-rule=\"evenodd\" d=\"M12.003 1.797a.751.751 0 00-.216-.527L10.733.217a.751.751 0 00-1.053 0L4.6 5.305 2.323 3.02a.751.751 0 00-1.053 0L.217 4.073a.751.751 0 000 1.054l3.856 3.856a.751.751 0 001.054 0l6.66-6.66a.751.751 0 00.216-.526z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol